(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref913"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref913"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b4v9R", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $80f83cca1ea11c6d$export$6503ec6e8aabbaf; }, function (v) { return $80f83cca1ea11c6d$export$6503ec6e8aabbaf = v; });
var $80f83cca1ea11c6d$export$6503ec6e8aabbaf;
var $80f83cca1ea11c6d$export$f7ad0328861e2f03;
"use strict";
var $80f83cca1ea11c6d$var$mapping = new Map();
function $80f83cca1ea11c6d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$80f83cca1ea11c6d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $80f83cca1ea11c6d$var$resolve(id) {
    var resolved = $80f83cca1ea11c6d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$80f83cca1ea11c6d$export$6503ec6e8aabbaf = $80f83cca1ea11c6d$var$register;
$80f83cca1ea11c6d$export$f7ad0328861e2f03 = $80f83cca1ea11c6d$var$resolve;

});

parcelRegister("4h0xY", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $31c92c8c4a48273e$export$bdfd709ae4826697; }, function (v) { return $31c92c8c4a48273e$export$bdfd709ae4826697 = v; });
var $31c92c8c4a48273e$export$bdfd709ae4826697;
var $31c92c8c4a48273e$export$c9e73fbda7da57b6;
var $31c92c8c4a48273e$export$5a759dc7a1cfb72a;
"use strict";
var $31c92c8c4a48273e$var$bundleURL = {};
function $31c92c8c4a48273e$var$getBundleURLCached(id) {
    var value = $31c92c8c4a48273e$var$bundleURL[id];
    if (!value) {
        value = $31c92c8c4a48273e$var$getBundleURL();
        $31c92c8c4a48273e$var$bundleURL[id] = value;
    }
    return value;
}
function $31c92c8c4a48273e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $31c92c8c4a48273e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $31c92c8c4a48273e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $31c92c8c4a48273e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$31c92c8c4a48273e$export$bdfd709ae4826697 = $31c92c8c4a48273e$var$getBundleURLCached;
$31c92c8c4a48273e$export$c9e73fbda7da57b6 = $31c92c8c4a48273e$var$getBaseURL;
$31c92c8c4a48273e$export$5a759dc7a1cfb72a = $31c92c8c4a48273e$var$getOrigin;

});

var $73d2f9ef239a953f$exports = {};


(parcelRequire("b4v9R")).register((parcelRequire("4h0xY")).getBundleURL("ju1jN"), JSON.parse('["ju1jN","index.3ab59b18.js","7KWiO","download_button.58a50430.png","gsg4L","preview_button.c3cea256.png"]'));

})();
//# sourceMappingURL=index.runtime.574e1eab.js.map
